export function buildDepartmentFilterMap(
  jobDepartments: Array<{
    personioDepartmentName?: string | null;
    filterOption?: {
      translatedDisplayName?: string | null;
    } | null;
  }>,
): Map<string, string> {
  const map = new Map<string, string>();

  for (const entry of jobDepartments) {
    const personioName = entry.personioDepartmentName?.trim();
    const label = entry.filterOption?.translatedDisplayName?.trim();
    if (!personioName || !label) continue;
    map.set(personioName.toLowerCase(), label);
  }

  return map;
}

export function resolveDepartmentFilterLabel(
  department: string,
  departmentParent: string | undefined,
  departmentFilterByPersonioName: Map<string, string>,
): string | undefined {
  const cmsLabel =
    departmentFilterByPersonioName.get(department.trim().toLowerCase()) ??
    (departmentParent
      ? departmentFilterByPersonioName.get(departmentParent.trim().toLowerCase())
      : undefined);

  if (cmsLabel) return cmsLabel;

  return departmentParent?.trim() || undefined;
}
